import React from 'react'
import { UpdateAsset } from './UpdateAsset'
import { LogViewer } from './LogViewer'

interface Props {
    selected: {
        asset: {
            id: string
            name: string
        }
    }
}

export const AssetSetupForm: React.FC<Props> = ({ selected }: Props) => {
    return (
        <div>
            <UpdateAsset selected={selected} />
            <LogViewer selected={selected} />
        </div>
    )
}

export default AssetSetupForm
